import React from "react"

// styling
import styled from "@emotion/styled"

// components
import { Row, Col, Space, Typography, List, Divider, Button } from "antd"
import { DoubleRightOutlined } from "@ant-design/icons"

// configs
import config from "config"

// store
import { useTranslation } from "react-i18next"

// utils
import { formatAsCurrency } from "utils/currency"
import OrderStatusTag from "./OrderStatusTag"

const UserOrderList = styled.div`
  overflow: hidden;

  .ant-list {
    overflow: hidden;
  }

  .ant-list-item {
    background: #4b4b4b;
    border-bottom: 1px solid #fafafa;

    &:hover {
      background: #5a5a5a;
      cursor: pointer;
      transition: background 0.1s ease-in-out;
    }
  }

  .ant-tag {
    border: none;

    * {
      color: black;
    }
  }
`

const UserOrderListComponent = ({ data, onSelect }) => {
  const { t } = useTranslation()

  return (
    <UserOrderList data-testid="user-orders">
      <Divider
        orientation="left"
        style={{
          borderTopColor: config.textColor,
        }}
      >
        <Typography.Title
          level={4}
          italic
          style={{
            fontSize: 20,
            margin: 0,
            color: config.textColor,
            // fontWeight: "lighter",
          }}
        >
          {t("my_orders")}
        </Typography.Title>
      </Divider>

      <List
        data-testid="user-order-list"
        style={{ background: "#4b4b4b" }}
        bordered
        size="small"
        dataSource={data}
        renderItem={(order, index) => (
          <List.Item
            style={{ width: "100%" }}
            onClick={() => {
              onSelect(order.id)
            }}
          >
            <div style={{ width: "100%" }}>
              <Row justify="space-between" style={{ width: "100%" }}>
                <Col xxl={20} xl={20} lg={20} md={18} sm={16} xs={12}>
                  <Space direction="vertical">
                    <Space wrap>
                      <Typography.Text
                        strong
                        style={{
                          color: "white",
                        }}
                      >
                        {t("order_heading", {
                          id: order.id.toUpperCase().slice(0, 4),
                        })}
                      </Typography.Text>

                      <OrderStatusTag order={order} />
                    </Space>
                  </Space>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={6}
                  sm={8}
                  xs={12}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  <Space align="center" style={{ height: "100%" }}>
                    <Button type="primary" size="small">
                      <Typography.Text
                        italic
                        style={{
                          color: "white",
                        }}
                      >
                        ({formatAsCurrency(order.total || 0)})
                      </Typography.Text>

                      {t("details")}

                      <DoubleRightOutlined />
                    </Button>
                  </Space>
                </Col>
              </Row>
            </div>
          </List.Item>
        )}
      />
    </UserOrderList>
  )
}

export default UserOrderListComponent
